import React from 'react';
import OrderForm from './OrderForm'
import { getStyle } from '../../styles/styles';
import NewEditableGrid from '../shared/NewEditableGrid';
import { searchOrder } from '../../networking/NetworkingDeals';
import { getOrderInfo } from '../../networking/NetworkingOrders';
import { EditOutlined,PrinterOutlined } from '@ant-design/icons';
import { formatDate } from '../../helpers/FormatHelper';
import { Print } from "../tools/print/PrintLabel"
var style = getStyle();

export default class OrderSearchScreen extends React.Component {
    
    state = {
        orders: [],
        columnDetail: {},
        valueDateFrom: '',
        valueDateTo: ''
    }
    componentDidMount() {        
        if(this.props.lockedSide!==undefined && this.props.lockedSide!==null){

            let valueDateTo = formatDate(new Date());
            let valueDateFrom1 = new Date();
            valueDateFrom1.setDate(valueDateFrom1.getDate() - 5);
            let valueDateFrom = formatDate(valueDateFrom1);

            var objFilter = {
                OrderDateFrom: valueDateFrom,
                OrderDateTo: valueDateTo,
                LockedSide: this.props.lockedSide
            };
            this.setState({ valueDateFrom: valueDateFrom, valueDateTo: valueDateTo });
            this.searchDealsGrid(objFilter);
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.lockedSide !== this.props.lockedSide) {
            var objFilter = {
                LockedSide: this.props.lockedSide
            };
            this.searchDealsGrid(objFilter);
            this.clearGrid();
        }
    } 
    
    clearGrid() {
        this.setState({ orders: [], columnDetail: {} });
    }

    searchDealsGrid(obj) {
        if(this.props.lockedSide!==undefined && this.props.lockedSide!==null){
            obj={ ...obj, LockedSide: this.props.lockedSide };
        }
        searchOrder(obj).then(
            (json) => {
                if(Number(json.httpStatusCode) === 200){
                    let columnDetail = JSON.parse(json.columnDetail);
                    let totalCount = json.totalCount;
                    let orders = json.bnorders;                    
                    this.setState({orders: orders, columnDetail: columnDetail});
                }
                else {
                    /*var alertMessage;
                    if(json.Message !== undefined){
                        alertMessage = json.Message;
                    }
                    else{
                        alertMessage = 'Search failed. Please try again or contact the administrator';
                    }
                    this.setState({alertMessage: alertMessage,
                        alertTitle: 'Error',
                        showAlert: true,
                    });*/
                }            
            }
        );
    }

    handleRowClick=async(obj)=>{
        if(this.props.onOrderSelected)
        {
            const responseOrder = await getOrderInfo(obj.BNOrderNo);
            if(responseOrder)
            {
                this.props.onOrderSelected(responseOrder);
            }
        }
    }

    PrinterClick=async(obj)=>{
        if(this.props.onOrderSelected)
        {
            Print(obj.BNOrderNo);
        }
    }
        
    render() {
        return (
            <div>
                <h3 className="uk-heading-divider" style={style.titleStyle}>Order Search</h3>                    
                <OrderForm lockedSide={this.props.lockedSide} valueDateTo={this.state.valueDateTo} valueDateFrom={this.state.valueDateFrom} searchDealsGrid={this.searchDealsGrid.bind(this)} clearGrid={this.clearGrid.bind(this)}/>
                <hr/>
                <div style={{ visibility: this.state.isVisible }}>
                    <NewEditableGrid
                        data={this.state.orders}
                        columnDetails={this.state.columnDetail}
                        isEditable={false}         
                        useIcons={true}
                        usePrintLabel={true}
                        dynamicActions={[
                            {name: 'Edit', function: this.handleRowClick, isIcon: true, icon: <EditOutlined /> },
                            {name: 'Print', function: this.PrinterClick, isIcon: true, icon: <PrinterOutlined /> }
                            ]} />
                        
                </div>
            </div>
        );
    }

}